/**
 * Vai trò tài khoản, khớp `USER_ROLES` ở backend
 * (`be-express/src/modules/user/user.constants.ts`). Giá trị được lưu nguyên văn
 * vào `user.role`, nên đổi ở đây phải đổi cả hai phía kèm migration dữ liệu.
 */
export const USER_ROLES = {
	admin: "admin",
	manager: "manager",
	user: "user",
	viewer: "viewer",
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

/**
 * Nhãn tiếng Việt của từng vai trò, dùng chung cho form tạo/sửa người dùng và
 * danh sách quản lý.
 *
 * Trước đây ba nhãn này được viết cứng ở ba nơi; thêm vai trò thứ tư mà bỏ sót
 * một nơi thì tài khoản hiện ra với mã thô (`viewer`) thay vì tên đọc được, và
 * không có gì báo lỗi.
 */
export const ROLE_LABELS: Record<UserRole, string> = {
	admin: "Quản trị viên",
	manager: "Quản lý",
	user: "Người dùng",
	viewer: "Chỉ xem",
};

/** Thứ tự hiện trong ô chọn vai trò: từ ít quyền tới nhiều quyền. */
export const ROLE_OPTIONS: readonly UserRole[] = [
	USER_ROLES.viewer,
	USER_ROLES.user,
	USER_ROLES.manager,
	USER_ROLES.admin,
];

/** Nhãn để hiển thị; vai trò lạ trong dữ liệu cũ thì hiện nguyên mã. */
export function roleLabel(role: string | null | undefined): string {
	if (!role) return ROLE_LABELS.user;
	return ROLE_LABELS[role as UserRole] ?? role;
}

/**
 * Tài khoản này chỉ được ĐỌC dữ liệu sinh viên, không được ghi.
 *
 * Đây chỉ là lớp giao diện — server chặn thật ở `denyReadOnly`. Khoá nút ở đây là
 * để người dùng không bấm vào thứ chắc chắn thất bại, KHÔNG phải để bảo vệ dữ
 * liệu; đừng bỏ chốt phía server vì đã có chốt này.
 */
export function isReadOnlyUser(user: { role?: string | null } | null | undefined): boolean {
	return user?.role === USER_ROLES.viewer;
}
